import axios from "axios";
import {getTokenFromStorage} from "../authStorage/storageTokenOperations";

const axiosInstanceUnauth = axios.create({
	baseURL: window.location.origin
});

const axiosInstance = axios.create({
	baseURL: window.location.origin
});

axiosInstance.interceptors.request.use((config) => {
	const token = getTokenFromStorage();
	if (token !== null) {
		config.headers.Authorization = `Bearer ${token}`;
	}
	return config;
});

export {axiosInstance, axiosInstanceUnauth}